<template>
  <svg
    id="Application-Window--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Application Window Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1.5 2C0.671573 2 0 2.67157 0 3.5v17c0 0.8284 0.671573 1.5 1.5 1.5h21c0.8284 0 1.5 -0.6716 1.5 -1.5v-17c0 -0.82843 -0.6716 -1.5 -1.5 -1.5h-21ZM3 7v12h18V7H3Zm0 -1.5c0.55228 0 1 -0.44772 1 -1s-0.44772 -1 -1 -1 -1 0.44772 -1 1 0.44772 1 1 1Zm5 -1c0 0.55228 -0.44772 1 -1 1s-1 -0.44772 -1 -1 0.44772 -1 1 -1 1 0.44772 1 1Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
